/* src/views/logements/parcDirty.js — LA GARDE ANTI-PERTE SILENCIEUSE (lot 4,
   décision Dimitri 2026-08-28, minimum du chantier de socle) : un registre
   d'une case que LogementsV2 tient à jour, et que App consulte avant de
   quitter la destination Logements. Pas la refonte — juste ne plus perdre
   de travail en silence. */

let dirty = false

export function poserParcDirty(v) { dirty = v === true }
export function parcEstDirty() { return dirty }

export const GARDE_PARC_TEXTE =
  'Des saisies attendent la pastille « Enregistrer » de la fiche logement. ' +
  'Quitter maintenant les perdrait. Quitter quand même ?'
